import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
	ApiKey,
	ApiUrl,
	WebUrl,
	TransactionType,
	TransactionStatus,
	LanguageKey,
	AccessRight,
} from "../../util/Constant.js";
import ApiEngine from "../../util/ApiEngine.js";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { checkIfPermissionExist } from "../../util/PermissionChecker.js";
import { Panel, PanelBody } from "../../components/panel/panel.jsx";
import PromotionDetail from "../configuration/PromotionDetail.js";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import queryString from "query-string";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import { stringIsNullOrEmpty, navigateTo } from "../../util/Util.js";

const PromoAndCoinRollover = (props) => {
	let _history = useHistory();
	const { t, i18n } = useTranslation(LanguageKey._PRIMARY);
    const _userData = useSelector(state => state.authState.userData);
	const [promoData, setPromoData] = useState([]);
	const _dispatch = useDispatch();
	const [showConfirmation, setShowConfirmation] = useState(false);
	let role1IsAllowed = checkIfPermissionExist(
		AccessRight._RESET_ROLLOVER_PERMISSION,
		true
	);
	const [isRefund, setIsRefund] = useState(false);

	let _tableColumns = [
		{
			id: "claim-id",
			Header: "",
			columns: [
				{
					id: "c-id",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>
							{t("CLAIM")} <br /> {t("ID")}
						</div>
					),
					Cell: ({ row }) => {
						return <>{row.original.claimId}</>;
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
			style: {
				whiteSpace: "unset",
				wordBreak: "break-word",
			},
		},
		{
			id: "claim-date",
			Header: "",
			columns: [
				{
					id: "c-date",
					Header: () => (
						<div style={{ whiteSpace: "unset",minWidth: "80px"  }}>
							{t("CLAIM")} <br /> 
							{t("DATE")+" (UTC+"+_userData.userTimeZone+")"}
						</div>
					),
					Cell: ({ row }) => {
						return <>{row.original.claimTime}</>;
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "promo-id",
			Header: "",
			columns: [
				{
					id: "p-id",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>
							{t("PROMO")} <br /> {t("ID")}
						</div>
					),
					Cell: ({ row }) => {
						return (
							<>{row.original.promoId}</>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "promo-title",
			Header: "",
			columns: [
				{
					id: "p-title",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>{t("PROMOTION_TITLE")}</div>
					),
					Cell: ({ row }) => {
						return (
							<>
								{row.original.remark == null
									? row.original.promoTitle
									: JSON.parse(row.original.remark).Name}
							</>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "deposit-id",
			Header: "",
			columns: [
				{
					id: "d-id",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>
							{t("DEPOSIT")} <br /> {t("ID")}
						</div>
					),
					Cell: ({ row }) => {
						return stringIsNullOrEmpty(row.original.depositId) ? (
							"-"
						) : (
							<a
								className="link-item"
								onClick={() => {
									handleClick("deposit", row.original.depositId);
								}}
							>
								{row.original.depositId}
							</a>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "deposit-amt",
			Header: "",
			columns: [
				{
					id: "d-amt",
					Header: () => (
						<div style={{ whiteSpace: "unset", textAlign: "right" }}>
							{t("DEPOSIT")} <br /> {t("AMOUNT")}
						</div>
					),
					Cell: ({ row }) => {
						return (
							<div style={{ textAlign: "right" }}>
								{(row.original.depositAmount).toFixed(2)}
							</div>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "bonus-amt",
			Header: "",
			columns: [
				{
					id: "b-amt",
					Header: () => (
						<div style={{ whiteSpace: "unset", textAlign: "right" }}>
							{t("BONUS")} <br /> {t("AMOUNT")}
						</div>
					),
					Cell: ({ row }) => {
						return (
							<div style={{ textAlign: "right" }}>
								{(row.original.bonusAmount).toFixed(2)}
							</div>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "coin-balance",
			Header: () => <div className="text-center">{t("COIN_BALANCE")}</div>,
			disableSortBy: true,
			columns: [
				{
					id: "initial",
					Header: ({ column }) => {
						return <div style={{ textAlign: "right" }}>{t("INITIAL")}</div>;
					},
					Cell: ({ row }) => (
						<div style={{ textAlign: "right" }}>
							{(row.original.initialBalance).toFixed(2)}
						</div>
					),
					disableSortBy: true,
				},
				{
					id: "current",
					Header: ({ column }) => {
						return <div style={{ textAlign: "right" }}>{t("CURRENT")}</div>;
					},
					Cell: ({ row }) => (
						<div style={{ textAlign: "right" }}>{(row.original.bonusWallet).toFixed(2)}</div>
					),
					disableSortBy: true,
				},
			],
		},
		{
			id: "coin-rollover",
			Header: () => <div className="text-center">{t("COIN_ROLLOVER")}</div>,
			disableSortBy: true,
			columns: [
				{
					id: "criteria",
					Header: ({ column }) => {
						return <div style={{ textAlign: "right" }}>{t("CRITERIA")}</div>;
					},
					Cell: ({ row }) => (
						<div style={{ textAlign: "right" }}>
							
							{row.original.remark == null
								? row.original.rolloverRate
								: JSON.parse(row.original.remark).PromotionType == 4 ? "x" + JSON.parse(row.original.remark).RolloverMultiplier
									: JSON.parse(row.original.remark).PromotionType == 3 ? JSON.parse(row.original.remark).RolloverType == 1 ? "x" + JSON.parse(row.original.remark).RolloverMultiplier : + (JSON.parse(row.original.remark).RolloverFixed).toFixed(2)
								: "x" + JSON.parse(row.original.remark).RolloverRate}
						</div>
					),
					disableSortBy: true,
				},
				{
					id: "progress",
					Header: ({ column }) => {
						return <div>{t("PROGRESS")}</div>;
					},
					Cell: ({ row }) => (
						<div>
							{(row.original.rolloverTarget - row.original.rolloverBalance).toFixed(2) }{" "}
							/ {(row.original.rolloverTarget).toFixed(2)}
						</div>
					),
					disableSortBy: true,
				},
			],
		},
		{
			id: "promo-coin-target",
			Header: "",
			columns: [
				{
					id: "cointarget",
					Header: () => (
						<div style={{ whiteSpace: "normal" }}>{t("MIN_COIN_TARGET")}</div>
					),
					Cell: ({ row }) => {
						return (
							<div style={{ textAlign: "right" }}>
								{(row.original.minCoinTarget).toFixed(2)}
							</div>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "promo-status",
			Header: "",
			columns: [
				{
					id: "status",
					Header: () => (
						<div style={{ whiteSpace: "unset", textAlign: "right" }}>{t("STATUS")}</div>
					),
					Cell: ({ row }) => {
						return (
							<div style={{ textAlign: "right"}}>
								{row.original.isCancel ? (
									<span className="text-rejected font-bold">
										{row.original.cancelRefund===true?t("CANCEL_AND_REFUND"):t("CANCELLED")}
									</span>
								) : row.original.isCleared ? (
									<span className="text-approved font-bold">
										{t("CLEARED")}
										<br />({t("BALANCE")} : {row.original.remainingBalance})
									</span>
								) : (
									<span className="text-rejected font-bold">{t("ACTIVE")}</span>
								)}
							</div>
						);
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "cleared-date",
			Header: "",
			columns: [
				{
					id: "c-at",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>{t("CLEARED_AT") +" (UTC+"+_userData.userTimeZone+")"}</div>
					),
					Cell: ({ row }) => {
						return <>{row.original.isCancel ? "-" : row.original.clearedAt}</>;
					},
					disableSortBy: true,
				},
			],
			disableSortBy: true,
		},
		{
			id: "promo-action",
			Header: "",
			columns: [
				{
					id: "action",
					Header: () => (
						<div style={{ whiteSpace: "unset" }}>{t("ACTION")}</div>
					),
					Cell: ({ row }) => {
						return row.original.isCancel ? (
							<span className="text-rejected font-bold">
								{t("CANCELLED_BY")} : {row.original.cancelBy}
								<br />
								{t("DATE")} : {row.original.cancelAt}
							</span>
						) : (
								!row.original.isCleared && role1IsAllowed && (
								<div style={{ display: "flex" }}>
									<button
										type="button"
										className="btn btn-danger"
										onClick={() => {
											setIsRefund(false);
											setShowConfirmation(true);
										}}
									>
										{t("CANCEL")}
									</button>

									<div className="tool-tip-with-text ml-2">
										<TitleTooltip placement="top" title={tooltipContent}>
											<img
												src={require("../../../src/assets/img/icon-info.png")}
												className="img-responsive"
												alt="icon"
												style={{ height: "1rem" }}
											/>
										</TitleTooltip>
									</div>
								</div>
							)
						);
					},
					disableSortBy: true,
					style: { overflow: "visible", minWidth: "290px" },
				},
			],
			disableSortBy: true,
			width: 100,
		},
	];

	async function cancelPromo(status) {
		if (status == "Active") {
			var responseJson = await ApiEngine.post(
				ApiUrl._API_CANCEL_PROMO +
					"?memberId=" +
					props.id +
					"&refund=" +
					isRefund
			);
			if (responseJson[ApiKey._API_SUCCESS_KEY]) {
				_dispatch(
					showMessage(
						responseJson[ApiKey._API_SUCCESS_KEY],
						t(responseJson[ApiKey._API_MESSAGE_KEY])
					)
				);
				getBonusData();
			} else {
				_dispatch(
					showMessage(
						responseJson[ApiKey._API_SUCCESS_KEY],
						t(responseJson[ApiKey._API_MESSAGE_KEY])
					)
				);
				getBonusData();
			}
		}
	}

	useEffect(() => {
		getBonusData();
	}, []);

	async function getBonusData() {
		var responseJson = await ApiEngine.get(
			ApiUrl._API_GET_MEMBER_PROMOTION + "?memberId=" + props.id
		);

		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			if (!stringIsNullOrEmpty(responseJson[ApiKey._API_DATA_KEY])) {
				setPromoData(responseJson[ApiKey._API_DATA_KEY]);
			}
		}
	}

	function TitleTooltip({ children, placement = "top", title = "" }) {
		return (
			<OverlayTrigger
				placement={placement}
				overlay={
					<Tooltip id={`tooltip-${placement}`} className="tooltip-font-size">
						{title}
					</Tooltip>
				}
			>
				{/* Render the child element */}
				{children}
			</OverlayTrigger>
		);
	}

	// Use JSX inside the TitleTooltip for better formatting
	const tooltipContent = (
		<>
			{t("NOTES")}:
			<br />
			1. {t("CANCEL_PROMOTION")}
		</>
	);

	const tooltipContent2 = (
		<>
			{t("NOTES")}:
			<br />
			1. {t("CANCEL_REFUND")}
		</>
	);

	const revertNotes = (
		<>
			{t("IMPORTANT_NOTES")}:
			<br />
			1. {t("CHECK_FEATURED_SPINS")} <br />
			2. {t("RECEIVE_COIN_ROLLOVER_PROGRESS")} <br />
			3. {t("TRANSFER_COINS_BACK")}
		</>
	);

	const handleClick = (type, id) => {
		let targetUrl = "";
		if (type == "deposit") {
			targetUrl = `${WebUrl._URL_VIEW_TRANSACTION_DETAIL}?memberId=${props.id}&id=${id}`;
		} else {
			targetUrl = `${WebUrl._URL_CLAIMED_PROMOTION_DETAIL}?id=${id}`;
		}

		console.log(targetUrl);
		// Open the URL in a new tab
		window.open(targetUrl, "_blank");
	};

	return (
		<>
			{showConfirmation && (
				<SweetAlert
					warning
					showCancel
					confirmBtnText={t("CONFIRM")}
					cancelBtnText={t("CANCEL")}
					confirmBtnBsStyle="danger"
					title={
						isRefund
							? t("ARE_YOU_SURE_TO_CANCEL_THE_PROMO_AND_REFUND")
							: t("ARE_YOU_SURE_TO_CANCEL_THE_PROMO")
					}
					onConfirm={() => {
						cancelPromo("Active");
						setShowConfirmation(false);
					}}
					onCancel={() => {
						setShowConfirmation(false);
					}}
				>
					{t("UNABLE_TO_REVERT")}
				</SweetAlert>
			)}
			<Panel className="mb-0 pr-2 pl-2">
				<PanelBody>
					<div className="row">
						<div className="col-lg-12">
							<span className="purple-note">
								<b>{revertNotes}</b>
							</span>
						</div>
					</div>
				</PanelBody>

				<ReactTable
					data={promoData}
					columns={_tableColumns}
					globalFilterable={false}
				/>
			</Panel>
		</>
	);
};

export default PromoAndCoinRollover;
